import React, { useEffect } from "react"
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton } from "@mui/material";
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import FilterCard from "./FilterCard";
import { ContactFilterData, FilterData } from "./FilterData";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../store";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { addCallReportFilter, addCallsFilter, addChartFilter, addContactFilter, addContactReportFilter, addConversationDetailFilter, addConversationFilter, addConversationReportFilter, clearFilter, setChartFilter, addOptimizationReportFilter } from "../../store/filter/filterReducer";
import { getFilterValues } from "../../utils/getFilterValues";
import axios from "axios";
import { logOut } from "../../utils/logOut";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TranslatedText from "../../utils/Translate";
import { useSnackbar } from "../../utils/SnackbarContext";

//Customize Accardion component
const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
        borderBottom: 1
    },
    '&:before': {
        display: 'none',
    },
}));

const ITEM_HEIGHT = 48;



export default function Filter({ fetchData, page, filter = [], exclude = [], filtersList = ContactFilterData}: any) {
    const dispatch = useAppDispatch()

    const { showSnackbar } = useSnackbar();

    useEffect(() => {
        if (page === 'chart' && filter.length !== 0) {
            dispatch(setChartFilter(filter))
        }
    }, [])

    const [openDialog, setOpenDialog] = React.useState(false);

    const filters = useSelector((state: any) => excludeObjects(state.filter.filterUserData[page]))
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [partners, setPartners] = React.useState([]);
    const [campaigns, setCampaigns] = React.useState([]);
    const [users, setUsers] = React.useState([]);
    const [conversationTemplates, setConversationTemplates] = React.useState([]);
    const [contactGroups, setContactGroups] = React.useState([]);
    const [accExpand, setAccExpand] = React.useState(false);
    const open = Boolean(anchorEl);

    function excludeObjects(arr: any) {
        return arr.filter((obj: any) => !exclude.includes(obj.params[0].type));
    }

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget);
    };

    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };



    console.log(useSelector((state: any) => state.filter.filterUserData[page]));



    const handleAdd = (event: any, addFilter: object) => {
        event.stopPropagation()
        setAccExpand(true)
        setAnchorEl(null);
        dispatch(
            page === 'contactreport' ? addContactReportFilter(addFilter) :
                page === 'callreport' ? addCallReportFilter(addFilter) :
                    page === 'optimizationtemplate' ? addOptimizationReportFilter(addFilter) :
                        page === 'calls' ? addCallsFilter(addFilter) :
                            page === 'conversationreport' ? addConversationReportFilter(addFilter) :
                                page === 'conversationdetail' ? addConversationDetailFilter(addFilter) :
                                    page === 'conversation' ? addConversationFilter(addFilter) :
                                        page === 'chart' ? addChartFilter(addFilter) :
                                            addContactFilter(addFilter)
        )

    };

    const handleClose = (event: any) => {
        event.stopPropagation()
        setAnchorEl(null);

    };

    //Save filter Data in localstorage
    const saveFilter = (page: any) => {
        localStorage.setItem(`${page}_filter`, JSON.stringify(filters));

    };
    console.log(filters);

    interface Filter {
        [key: string]: string;
    }

    //Get partners data
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                setPartners(response.data)
            }

        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get campaign data
    async function getCampaigns(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/campaign`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                setCampaigns(response.data)
            }

        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    async function getUsers(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/user`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setUsers(response.data)
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    

    async function getConversationTemplates(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setConversationTemplates(response.data)
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    async function getContactGroups(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/contactgroup`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setContactGroups(response.data)
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //On load get partners for select field
    useEffect(() => {
        getCampaigns()
        getPartners()
        getUsers()
        getConversationTemplates()
        getContactGroups()
    }, [])

    //Filtering the list of filters depending on the ones used
    const filterData = (data: any, filters: Filter[]): any[] => {
        const filteredData = data.filter((item: any) => {
            return !filters.some((filter) => {
                return Object.keys(filter).every((key) => {
                    return item[key] === filter[key];
                });
            });
        });

        return filteredData;
    };

    const filteredData = filterData(filtersList, filters);


    console.log(getFilterValues(filters));


    return (
        <>
            <Accordion expanded={accExpand} sx={{ mb: 1 }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    onClick={() => setAccExpand(!accExpand)}
                >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="button"><TranslatedText text="Filter" /></Typography>
                        <IconButton onClick={(e) => { e.stopPropagation(); handleClick(e) }} color="primary" aria-label="add" >
                            <AddCircleOutlineRoundedIcon fontSize="inherit" />
                        </IconButton>
                        <Menu
                            id="long-menu"
                            MenuListProps={{
                                'aria-labelledby': 'long-button',
                            }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={(e) => handleClose(e)}
                            PaperProps={{
                                style: {
                                    maxHeight: ITEM_HEIGHT * 4.5,
                                    // width: '40ch',
                                },
                            }}
                        >
                            {filteredData.filter(item => {
                                return !exclude.includes(item.params[0].type);
                            }).filter((obj: any) => !(filters).some((f: any) => f.name === obj.name)).map((option: any) => (
                                <MenuItem key={option.name} onClick={(event) => handleAdd(event, option)}>
                                    <TranslatedText text={option.name} />
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                </AccordionSummary>
                <AccordionDetails >
                    <Stack direction="row" sx={{ mb: 2, display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        {(filters).filter((item: any) => {
                            return !exclude.includes(item.params[0].type);
                        }).map((el: any) => {
                            return (
                                <FilterCard conversationtemplates={conversationTemplates} contactgroups={contactGroups} users={users} partners={partners} campaigns={campaigns} key={el.name} el={el} page={page} />
                            )
                        })}
                    </Stack>
                    <Button onClick={() => {
                        if (filters.length == 0) {
                            handleClickOpenDialog()
                        }
                        else {
                            fetchData(getFilterValues(filters));
                            
                        }

                        page !== 'chart' && saveFilter(page);
                    }} variant="contained"><Typography variant="button"><TranslatedText text="Apply" /></Typography></Button>
                </AccordionDetails>
            </Accordion>
            <Dialog open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle><TranslatedText text="Alert" /></DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ mb: 3 }}>
                    <TranslatedText text="You are trying to get data without a filter, it can be a large amount of data and will take a lot of time..." />

                    </DialogContentText>
                    <Box sx={{ width: '100%', display: "flex", justifyContent: "center" }}>
                        <DialogContentText><TranslatedText text='(To add a filter, click the "+" button and select the desired one)' /></DialogContentText>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}><TranslatedText text="Cancel" /></Button>
                    <Button color="error" onClick={() => { fetchData(getFilterValues(filters)); handleCloseDialog() }}><TranslatedText text="Continue" /></Button>
                </DialogActions>
            </Dialog>
        </>
    )
}